<template>
  <PageContentHeading
    class="h3 text-center"
    :tag-name="tagName"
    :margin-bottom="marginBottom"
  >
    <slot />
  </PageContentHeading>
</template>

<script lang="ts">
import Vue from 'vue';
import PageContentHeading from './PageContentHeading.ts.vue';

export default Vue.extend({
  components: {
    PageContentHeading,
  },
  props: {
    tagName: {
      type: String,
      default: 'h1',
    },
    marginBottom: {
      type: Number,
      default: 2,
    },
  },
});
</script>
